import { DateString } from '@sdk/types';
import { AnalyticsEvents } from '@sdk/analytics/types';
import { ToastScheduleImportPageSource } from '@sdk/integrations/types';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { ClientFlagsProvider } from '@sdk/session/ClientFlagsContext';

import {
  CarouselFlex as Carousel,
  SingleCardModalContainer,
} from '@web/integrations/shiftScheduleImport/toastModalContent.styles';
import { SlideA } from '@web/integrations/shiftScheduleImport/SlideA';
import { ToastShiftScheduleModalProvider } from '@web/integrations/shiftScheduleImport/ToastShiftScheduleModalProvider';
import { TrackAnalyticsEvent } from '@web/integrations/shiftScheduleImport/types';

type Props = {
  importShiftSchedulesCallback: (date: DateString) => void;
  onClose: () => void;
  trackAnalyticsEvent: TrackAnalyticsEvent;
  currentUser: AuthUserType;
};

export const ToastModalContent = ({
  importShiftSchedulesCallback,
  onClose,
  trackAnalyticsEvent,
  currentUser,
}: Props) => {
  const sendModalVisibleAnalyticsEvent = () => {
    trackAnalyticsEvent(
      AnalyticsEvents.toastScheduleImportOpportunity,
      ToastScheduleImportPageSource.scheduleImportModal
    );
  };

  const actions = {
    importShiftSchedules: importShiftSchedulesCallback,
    close: onClose,
    sendModalVisibleAnalyticsEvent,
    currentUser,
  };

  return (
    <ClientFlagsProvider>
      <ToastShiftScheduleModalProvider actions={actions}>
        <SingleCardModalContainer>
          <SlideA key={'SlideA'} displayCloseButton={true} />
        </SingleCardModalContainer>
      </ToastShiftScheduleModalProvider>
    </ClientFlagsProvider>
  );
};
